import { render, staticRenderFns } from "./buyerppv.vue?vue&type=template&id=6ccdba9d&scoped=true&"
import script from "./buyerppv.vue?vue&type=script&lang=js&"
export * from "./buyerppv.vue?vue&type=script&lang=js&"
import style0 from "./buyerppv.vue?vue&type=style&index=0&id=6ccdba9d&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ccdba9d",
  null
  
)

export default component.exports